module.exports = __webpack_public_path__ + "img/quote.ab031cd3.svg";